module.exports = __webpack_public_path__ + "static/img/logo06.7b5f4239.png";